import { ModuleWithProviders, NgModule } from '@angular/core';

import { CustomFontsService } from '../fonts/custom-fonts.service';
import { AccountColorsService } from './account-colors.service';
import { AccountService } from './account.service';
import { AccountColorsApi } from './api/account-colors.api';
import { AppStateService } from './app-state.service';
import { FeatureflagService } from './featureflag.service';
import { ImageEditorService } from './image-editor.service';
import { InboxPreviewService } from './inbox-preview.service';
import { WebContentDataService } from './web-content-data.service';

const providers = [
  AccountService,
  AppStateService,
  FeatureflagService,
  WebContentDataService,
  ImageEditorService,
  InboxPreviewService,
  CustomFontsService,
  AccountColorsService,
  AccountColorsApi,
];

@NgModule({
  imports: [],
  declarations: [],
  providers,
})
export class CommonServicesModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CommonServicesModule,
      providers,
    };
  }
}
